import { Phone, MessageCircle } from "lucide-react";
import { waMenuLink } from "@/data/site";

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      <a
        href={waMenuLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="call-floating-btn"
        aria-label="Chiamaci ora"
        className="w-12 h-12 rounded-full bg-terracotta text-cream grid place-items-center shadow-lg shadow-terracotta/30 hover:-translate-y-1 transition-transform duration-300"
      >
        <Phone size={19} />
      </a>
      <a
        href={waMenuLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-btn"
        aria-label="Scrivici su WhatsApp"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg shadow-[#25D366]/40 hover:-translate-y-1 transition-transform duration-300"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <MessageCircle size={24} className="relative" />
      </a>
    </div>
  );
}
